import * as Tooltip from "../components/tooltip";

$(document).ready(function (e) {
  if ($(document).find("#KiwisaverApplicationForm").length > 0) {
    $(document).on(
      "click",
      ".toggle-show-at-first:not(.disabled)",
      function () {
        $(document).find(".show-at-first").fadeOut(100);
        // Scroll the browser to the form__header
        var scrollDiv = document.querySelector(
          ".online-form__header"
        ).offsetTop;
        window.scrollTo({ top: scrollDiv, behavior: "smooth" });
      }
    );

    if ($(document).find(".field.checkbox")) {
      $(document)
        .find(".field.checkbox")
        .each(function () {
          var dom = $(this);
          var input = dom.find("input.checkbox");

          if (dom.hasClass("checkbox--reveal") && input.attr("href")) {
            dom.on("click", function (e) {
              if (input.is(":checked")) {
                input.prop("checked", false);
                input.val(0);

                // When we're not checked, open the link in a new window
              } else {
                input.prop("checked", true);
                input.val(1);
                window.open(input.attr("href"));
              }

              ToggleFields(input.val());

              e.preventDefault();
              return false;
            });
          }
        });
    }

    TogglableFields();
    PopupOnHover();
  }
});

function TogglableFields() {
  $(".toggle-trigger").click(function (e) {
    $(this)
      .parents(".toggle-fields")
      .children(".togglable-fields")
      .toggleClass("hide");
  });
}

function PopupOnHover() {
  if ($(document).find(".popup-on-hover")) {
    var trigger = $(document).find("a.popup-on-hover, input.popup-on-hover");
    var dom = trigger.parents(".field.has-hover-popup");
    $(dom)
      .on("mouseenter", ".popup-on-hover", function () {
        console.info($(this));
        $(this)
          .parents(".field.has-hover-popup")
          .find(".hover-popup")
          .toggleClass("hide");
      })
      .on("mouseleave", ".popup-on-hover", function () {
        $(this)
          .parents(".field.has-hover-popup")
          .find(".hover-popup")
          .toggleClass("hide");
      });
  }
}

function ToggleFields(value) {
  if ($(document).find(".field.checkbox--revealed a.u-button")) {
    var fields = $(document).find(".field.checkbox--revealed a.u-button");
    if (value == 1) {
      fields.removeClass("disabled popup-on-hover");
    } else {
      fields.addClass("disabled popup-on-hover");
    }
  }
}
